import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IStatus } from '../interfaces';
import { StatusMapper } from '../mappers';

export type IGetStatusByIdRepoResponse = IRepoResponse<200, IStatus> | IRepoResponse<400 | 500, string>;

export type IGetStatusByIdRepo = IRepo<[number | string], IGetStatusByIdRepoResponse>;

export const GetStatusByIdRepoType = Symbol.for('GetStatusByIdRepo');

@bind(GetStatusByIdRepoType)
export class GetStatusByIdRepo implements IGetStatusByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/states/getinfobystateid', { state_id: id }) });

      if (result.status === 200) {
        const data: IStatus = StatusMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
